import { render, staticRenderFns } from "./TypePersonal.vue?vue&type=template&id=3e9d9da0&scoped=true&"
import script from "./TypePersonal.vue?vue&type=script&lang=js&"
export * from "./TypePersonal.vue?vue&type=script&lang=js&"
import style0 from "./TypePersonal.vue?vue&type=style&index=0&id=3e9d9da0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9d9da0",
  null
  
)

export default component.exports